<div class="chart-container">
  <div class="card">
  <div class="my-3 header-4">{{ chartMeta.title }}</div>

    <div class="latest-coverage-badge" *ngIf="chartData?.data?.latest_coverage?.coverage">
      Latest Coverage: {{ chartData.data.latest_coverage?.coverage }}%
    </div>
    <div class="chart-card" *ngIf="chartData?.data?.coverage_history?.length > 0; else noDataTemplate">
      <p-chart type="bar" [data]="basicData" [options]="basicOptions"></p-chart>
    </div>

    <ng-template #noDataTemplate>
      <app-no-data></app-no-data>
    </ng-template>
  </div>
</div>
